import { useEffect, useState } from "react";
import request from "../../../utils/request";
import useFetch from "../../../hooks/useFetch";
import { Button, Card, Col, Row } from "react-bootstrap";
import { socket } from "./socket";
import toast from "react-hot-toast";

const SpecificTokenCalling = ({ counterId }) => {
  const [token, setToken] = useState("");

  const { data: todaysAllToken } = useFetch(() =>
    request.getAll(
      `queue-management/service-list/token/todays-all-token/${counterId}`
    )
  );

  const recallToken = async (token) => {
    socket.emit(
      "prevTokenCalling",
      { tokenId: token?.id, counterId: counterId },
      (response) => {
        if (response.success) {
          toast.success(`Token ${token?.token} called successfully`);
          // setTokenData(response.data);
          // playAudio(response?.data?.token, response?.data?.counter);
        } else {
          console.error("Error:", response.error);
          toast.error(response.error);
        }
      }
    );
  };

  return (
    <div>
      <Row>
        {todaysAllToken?.map((item) => (
          <Col
            sm={2}
            key={item.id}
            className="p-2"
            style={{
              height: "80px",
            }}
          >
            <Button
              className={` h-100 btn-outline-success text-white ${
                token === item.token ? "btn-success" : ""
              }`}
              key={item.id}
              style={{
                height: "100%",
                width: "100%",
              }}
              onClick={() => {
                setToken(item.token);
                recallToken(item);
              }}
            >
              {item.token}
            </Button>
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default SpecificTokenCalling;
